import { Box, Typography } from '@mui/material';
import React from 'react';
import CustomTooltip from '../CustomTooltip';
import * as Icon from '@mui/icons-material';
import { extractDataFromArray } from '../../utils/common';

export const AvailableOptionsList = ({ header, tooltip, list }) => {
    const validList = Array.isArray(list) ? list : []; // Ensure list is always an array

    if (validList.length === 0) return null; // Prevents rendering if the list is empty

    return (
        <Box sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                <Typography sx={{ fontWeight: 700 }}>{header}</Typography>
                {tooltip && (
                    <CustomTooltip content={<Typography>{tooltip}</Typography>} />
                )}
            </Box>
            {tooltip && (
                <Typography sx={{ color: 'var(--textGrey)', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {tooltip}
                </Typography>
            )}

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                {validList.map((amenity, i) => {
                    if (amenity === 'Others') return null;
                    return (
                        <Box sx={{ display: 'flex', gap: 1, flex: { xs: '100%', sm: '50%' }, width: '100%', mb: 1 }} key={`lodging_amenity_${i}`}>
                            <Icon.Verified color="primary" />
                            <Typography color="grey">{amenity}</Typography>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

function OthersExperience({ data }) {
    if (!data) return null; // Prevents rendering if data is missing

    const activitiesAllowed = extractDataFromArray(data, ['activities_allowed'], []) || [];
    const otherActivities = extractDataFromArray(data, ['other_activities'], []) || [];

    if (activitiesAllowed.length === 0 && otherActivities.length === 0) return null; // Prevents rendering if both lists are empty

    return (
        <>
            {activitiesAllowed.length > 0 && (
                <AvailableOptionsList header="Activities Allowed" list={activitiesAllowed} />
            )}
            {otherActivities.length > 0 && (
                <AvailableOptionsList header="Other Activities Allowed" list={otherActivities} />
            )}
        </>
    );
}

export default OthersExperience;
